// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__16wji","controls":"styles_controls__bHVbW","charLimit":"styles_charLimit__10GCY","input":"styles_input__2ZO-a","send":"styles_send__3Z2Si"};